import { Injectable } from '@angular/core';
import {UtilDocumentIdService} from './util-document-id.service';

@Injectable({
  providedIn: 'root'
})
export class SclUtilDocumentService {

  constructor(private utilDocumentIdService: UtilDocumentIdService) { }

  isNew(doc) {
    return !doc.systemHeader || !doc.systemHeader.createdDate;
  }

  getValidId(value) {
    let validValue;
    if (!value) {
      validValue = this.utilDocumentIdService.generateId();
    } else {
      validValue = value;
    }
    return validValue;
  }

}
